// SEO utility functions

export const truncateText = (text: string, maxLength: number): string => {
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength - 3) + '...';
};

export const generateJobTitle = (jobTitle: string, companyName: string, location: string): string => {
  return `${jobTitle} at ${companyName} - ${location}`;
};

export const generateJobDescription = (
  jobTitle: string, 
  companyName: string, 
  location: string, 
  jobType: string,
  salary?: { min?: number; max?: number; currency: string }
): string => {
  let desc = `Find ${jobTitle} position at ${companyName} in ${location}. ${jobType} opportunity`;
  
  if (salary?.min && salary?.max) {
    desc += ` with salary ${salary.currency} ${salary.min.toLocaleString()} - ${salary.max.toLocaleString()}`;
  } else if (salary?.min) {
    desc += ` with salary from ${salary.currency} ${salary.min.toLocaleString()}`;
  }
  
  desc += `. Apply now on GreatJobs.lk - Sri Lankan job board.`;
  
  return truncateText(desc, 160);
};

export const generateJobKeywords = (
  jobTitle: string,
  skills: string[] = [],
  location: string,
  jobType: string,
  experienceLevel: string
): string[] => {
  const baseKeywords = [
    jobTitle.toLowerCase(),
    `${jobTitle.toLowerCase()} job`,
    `${jobTitle.toLowerCase()} sri lanka`,
    `${jobTitle.toLowerCase()} ${location.toLowerCase()}`,
    `${jobType.toLowerCase()} jobs`,
    `${experienceLevel.toLowerCase()} jobs`,
    'sri lanka jobs',
    'job vacancies sri lanka',
    'careers sri lanka'
  ];

  const skillKeywords = skills.map(skill => `${skill.toLowerCase()} jobs`);
  
  return [...baseKeywords, ...skillKeywords].slice(0, 15); // Limit to 15 keywords
};

export const generateJobOGImage = (jobTitle: string, companyName: string, location?: string, salary?: { min?: number; max?: number; currency: string }): string => {
  const params = new URLSearchParams({
    type: 'job',
    title: truncateText(jobTitle, 45),
    company: truncateText(companyName, 35)
  });
  
  if (location) {
    params.set('location', truncateText(location, 20));
  }
  
  if (salary) {
    let salaryStr = '';
    if (salary.min && salary.max) {
      salaryStr = `${salary.currency} ${salary.min.toLocaleString()} - ${salary.max.toLocaleString()}`;
    } else if (salary.min) {
      salaryStr = `${salary.currency} ${salary.min.toLocaleString()}+`;
    }
    if (salaryStr) {
      params.set('salary', salaryStr);
    }
  }
  
  return `https://bxmcfcnljcqgongyckwk.supabase.co/functions/v1/generate-og-image?${params.toString()}`;
};

export const generateCompanyOGImage = (companyName: string, jobCount: number = 0): string => {
  const params = new URLSearchParams({
    type: 'company',
    company: truncateText(companyName, 40),
    jobCount: jobCount.toString()
  });
  
  return `https://bxmcfcnljcqgongyckwk.supabase.co/functions/v1/generate-og-image?${params.toString()}`;
};

export const generateCanonicalUrl = (path: string): string => {
  const baseUrl = 'https://greatjobs.lk';
  return `${baseUrl}${path.startsWith('/') ? path : `/${path}`}`;
};

export const formatJobPosting = (job: any) => {
  return {
    title: job.title,
    description: job.description,
    datePosted: job.created_at,
    validThrough: job.application_deadline,
    employmentType: job.job_type,
    experienceRequirements: job.experience_level,
    location: {
      name: job.location,
      addressCountry: "LK"
    },
    salary: job.salary_min || job.salary_max ? {
      min: job.salary_min,
      max: job.salary_max,
      currency: job.currency || "LKR"
    } : undefined,
    hiringOrganization: {
      name: job.companies?.name || 'Company',
      logo: job.companies?.logo_url,
      url: job.companies?.website,
      address: job.companies?.location || job.location
    },
    jobUrl: `https://greatjobs.lk/jobs/${job.id}`,
    skills: job.skills || []
  };
};